import React from "react";
import { Box, Stack, Card, Grid, CardMedia, Typography } from "@mui/material";
import Lottie from "lottie-react";
import { TeamTestimonialsSlider } from "./TeamTestimonialsSlider";
import { motion } from "framer-motion";

// Import your hero JSON animation
import heroAnimation from "../../assets/team/team.json";
import gana from "../../assets/team/ganeswaran.jpg";
import joice from "../../assets/team/joice.jpg";
import roman from "../../assets/team/roman2.png";

// Team members images
const teamMembers = [
  { id: 1, name: "E. Ganeshwaram", title: "CEO and Founder", image: gana },
  { id: 2, name: "J Joice Peries", title: "General Manager", image: joice },
  { id: 3, name: "Roman Figurado", title: "Operation Manager", image: roman },
];

const OurTeamContent = () => {
  return (
    <Box sx={{ bgcolor: "black", color: "white", overflow: "hidden", px: { xs: 2, md: 10 }, py: 4 }}>

      {/* ---------- Hero Section with Animation ---------- */}
      <Grid container>
        <Grid item xs={12} md={6} sx={{ textAlign: "center", overflow: "hidden" }}>
          <motion.div initial={{ x: 100, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 1 }}>
            <Box sx={{ width: { xs: "100%", md: "110%" }, height: { xs: 200, md: "auto" }, mx: "auto" }}>
              <Lottie animationData={heroAnimation} loop style={{ width: "100%", height: "100%", display: "inline-block" }} />
            </Box>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={6} sx={{ pl: { xs: 2, md: "70px" }, pt: { xs: 4, md: "141px" }, textAlign: { xs: "center", md: "left" } }}>
          <Stack spacing={2} alignItems={{ xs: "center", md: "flex-start" }}>
            <Typography variant="h4" sx={{ fontFamily: "Roboto-Bold, Helvetica", fontWeight: "bold", color: { xs: "#9e9e9e", md: "#ffffffa1" }, fontSize: { xs: 20, md: 36 }, lineHeight: 1.6 }}>
              Our Team
            </Typography>
            <Typography variant="h2" sx={{ fontFamily: "Roboto-Bold, Helvetica", fontWeight: "bold", color: "white", fontSize: { xs: 20, md: 53.8 }, lineHeight: { xs: 1.6, md: "63.4px" }, maxWidth: { xs: "100%", md: 524 }, mt: { xs: 0, md: "10px" }, textAlign: { xs: "center", md: "left" } }}>
              The People Behind the Product
            </Typography>
          </Stack>
          <Typography sx={{ fontFamily: "Roboto-Regular, Helvetica", color: "white", fontSize: { xs: 14, md: 24 }, lineHeight: { xs: 1.6, md: "26px" }, textAlign: { xs: "justify", md: "justify" }, maxWidth: { xs: "100%", md: 670 }, mt: { xs: 2, md: 5 } }}>
            We're a passionate, remote-first team working together to build smarter financial solutions for everyone in Sri Lanka.
            At Rubaai, we believe great things happen when good people come together no matter where they are.
          </Typography>
        </Grid>
      </Grid>

    {/* ---------- Leadership Team ---------- */}
<Typography sx={{ fontWeight: "bold", textAlign: "center", mt: 8, mb: 6, fontSize: { xs: 18, md: 36 } }}>
  Our leadership team
</Typography>

<Box
  sx={{
    display: "flex",
    flexDirection: "row",
    overflowX: { xs: "auto", md: "visible" }, // horizontal scroll for small screens
    gap: 4,
    px: { xs: 1, md: 0 },
    scrollSnapType: { xs: "x mandatory", md: "none" },
    "&::-webkit-scrollbar": { display: "none" }, // hide scrollbar
    justifyContent: {
      xs: "flex-start", // mobile scroll start
      md: "center", // desktop default
      xl: "center", // above 1220px, cards centered
    },
  }}
>
  {teamMembers.map(member => (
    <Card
      key={member.id}
      sx={{
        flex: { xs: "0 0 auto", md: "none" }, // do not stretch horizontally on mobile
        width: { xs: 247, md: 300 }, // keep desktop card width
        height: { xs: 331, md: 340 }, // keep desktop card height
        scrollSnapAlign: { xs: "start", md: "none" }, // snap cards to start for mobile
        position: "relative",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <CardMedia component="img" image={member.image} alt={member.name} sx={{ height: "100%", objectFit: "cover" }} />
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: { xs: 73, md: 73 },
          bgcolor: "rgba(0,0,0,0.8)",
          backdropFilter: "blur(2px)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Typography sx={{ color: "#ffffff", fontWeight: 600, fontSize: { xs: 16, md: 16 } }}>{member.name}</Typography>
        <Typography sx={{ color: "#ffffff", fontWeight: 400, fontSize: { xs: 14, md: 14 } }}>{member.title}</Typography>
      </Box>
    </Card>
  ))}
</Box>




      {/* ---------- Testimonials Section ---------- */}
      <Stack spacing={1.5} sx={{ mt: 8 }} alignItems="center">
        <Typography sx={{ color: { xs: "#9e9e9e", md: "#ffffffa1" }, lineHeight: 1.6, fontWeight: "bold", fontSize: { xs: 20, md: 36 } }}>
          Voices of Our Team
        </Typography>
        <Typography sx={{ fontWeight: "300", textAlign: "center", px: { xs: 2.5, md: 0 }, fontSize: { xs: 16, md: 24 }, maxWidth: { xs: "100%", md: 800 } }}>
          Real stories and perspectives from the people who make us <br />who we are.
        </Typography>
      </Stack>

      {/* Slider Cards */}
      <TeamTestimonialsSlider />

    </Box>
  );
};

export default OurTeamContent;
